import React from 'react';
import classNames from 'classnames';
import ExclamationIcon from 'icons/Exclamation.icon';
import useMatchMedia from 'hooks/useMatchMedia';

import './NoResultBanner.styles.scss';
import './NoResultBanner.styles.responsive.scss';

type NoResultBannerProps = {
  className?: string;
  title: string;
};

const NoResultBanner: React.FC<NoResultBannerProps> = (props) => {
  const { className, title } = props;

  const isMobile = useMatchMedia('isMobile');

  const classes = classNames('no-result-banner', className);

  return (
    <div className={classes}>
      {!isMobile && <ExclamationIcon />}
      {title}
    </div>
  );
};

export default NoResultBanner;
